import React, { useState, useEffect } from "react";
import { toasterState } from "Components/common/Toaster";
import Button from "Components/common/Button";
import makeApi, { URLS } from "Utils/apiURL";
import Utils from "Utils/utils";
import { settingsPopupState } from "./SettingsPopup";
import FormActionButtons from "./FormActionButtons";

import { customerDetails } from "Stores/customerDetails";

const ChangeSubscriptionPopupContent = (props) => {
  const {
    email = "",
    activeLabelList = {},
    setActiveLabelList = () => { },
    planDetails = {},
  } = props || {};

  const [buttonLoader, setButtonLoader] = useState(false);
  const [activePlans, setActivePlans] = useState([]);
  const [selectedPlan, setSelectedPlan] = useState(null);

  const updateSubscriptionValue = async (data = {}, email = "") => {
    if (email) {
      const config = {
        url: URLS.createPaidUser,
        method: "POST",
        data: { ...data, email: email },
      };
      let response = await makeApi(config);
      if (response?.data?.success) {
        setButtonLoader(false);
        settingsPopupState.setShowPopup(false);
        customerDetails.getCustomerDetails(email);
        toasterState.setToastMsg(
          "Subscriptions changed successfully",
          "success"
        );
      } else {
        Utils.showApiFailureResponse(response);
        settingsPopupState.setShowPopup(false);
      }
    } else {
      setButtonLoader(false);
    }
  };

  const handleUpdateSubscription = (e) => {
    e.preventDefault();
    setButtonLoader(true);
    const { changePlanType: planType = "" } = activeLabelList || {};

    if (!selectedPlan || !planType) {
      setButtonLoader(false);
      toasterState.setToastMsg("Please select both plan and type", "error");
      return;
    }

    const config = {};
    if (planType === "annual") {
      config.planId = selectedPlan?.annualPlanId;
      config.interval = 12;
      config.annual = true;
    } else {
      config.planId = selectedPlan?.monthlyPlanId;
      config.interval = 1;
      config.annual = false;
    }
    updateSubscriptionValue(config, email);
  };

  const handleChange = (value = "", event) => {
    const selectedValue = event?.currentTarget?.value;
    if (value === "changePlanName") {
      const plan = activePlans.find((p) => p.id === selectedValue);
      setSelectedPlan(plan);
      setActiveLabelList({
        ...activeLabelList,
        [value]: selectedValue,
        changePlanType: "", // Reset plan type when plan changes
      });
    } else {
      setActiveLabelList({
        ...activeLabelList,
        [value]: selectedValue,
      });
    }
  };

  const getActiveSubscriptionPlans = async () => {
    const config = {
      url: URLS.getActiveSubscriptionPlan,
      method: "GET",
    };
    let response = await makeApi(config);
    if (response?.data) {
      setActivePlans(response?.data);
    }
  };

  useEffect(() => {
    if (activePlans.length > 0) {
      const {
        planName = "",
        planType = "",
        subscriptionPlanCategory = "",
        subscriptionPlanId = "",
      } = planDetails || {};

      const currentPlan = activePlans.find((p) => {
        const isNameMatch = p.name?.toLowerCase() === planName?.toLowerCase();
        const isCategoryMatch =
          p.category?.toLowerCase() === subscriptionPlanCategory?.toLowerCase();
        const isIdMatch =
          p.monthlyPlanId === subscriptionPlanId ||
          p.annualPlanId === subscriptionPlanId;
        const matchedType =
          p.monthlyPlanId === subscriptionPlanId ? "monthly" : "annual";
        const isTypeMatch = matchedType === planType?.toLowerCase();

        return isNameMatch && isCategoryMatch && isIdMatch && isTypeMatch;
      });

      if (currentPlan) {
        setSelectedPlan(currentPlan);
        setActiveLabelList({
          ...activeLabelList,
          changePlanName: currentPlan.id,
          changePlanType: planType?.toLowerCase(),
        });
      }
    }
  }, [planDetails, activePlans]);

  useEffect(() => {
    getActiveSubscriptionPlans();
  }, []);

  const planOptions = activePlans.map((plan) => ({
    label:
      plan.name === "FREE" ? "Free" : `${plan.name} - ${plan.category || ""}`,
    value: plan.id,
  }));

  const typeOptions = [];
  if (selectedPlan) {
    if (selectedPlan.monthlyPlanId) {
      typeOptions.push({ label: "Monthly", value: "monthly" });
    }
    if (selectedPlan.annualPlanId) {
      typeOptions.push({ label: "Annual", value: "annual" });
    }
  }

  const dataConfig = [
    {
      label: "Plan",
      value: "changePlanName",
      type: "dropdown",
      options: planOptions,
    },
    {
      label: "Plan Type",
      value: "changePlanType",
      type: "dropdown",
      options: typeOptions,
    },
  ];

  return (
    <form
      className="changeSubscriptionWrapper"
      onSubmit={handleUpdateSubscription}
      onCancel={() => settingsPopupState?.setShowPopup(false)}
    >
      {dataConfig.map((item) => {
        const { label = "", value: itemValue = "", options = [] } = item || {};
        return (
          <div className="dataContainer" key={itemValue}>
            <div key={itemValue}>{label}</div>
            <select
              value={activeLabelList[itemValue] || ""}
              onChange={(e) => handleChange(itemValue, e)}
            >
              <option value="" disabled>
                Select {label}
              </option>
              {options?.map((option) => {
                const { label: optionLabel = "", value = "" } = option || {};
                return (
                  <option key={value} value={value}>
                    {optionLabel}
                  </option>
                );
              })}
            </select>
          </div>
        );
      })}
      <FormActionButtons
        submitBtnText="Update Plan"
        submitBtnClsName={`primaryButton updateSubscriptionButton ${buttonLoader ? "loading" : ""
          }`}
        cancelBtnClsName="secondaryButton cancelButton"
        cancel={() => settingsPopupState?.setShowPopup(false)}
        submitButtonLoader={buttonLoader}
      />
    </form>
  );
};

const ChangeSubscriptionPlan = (props) => {
  const { source = "changeSubscription" } = props || {};

  const handleChangeSubscription = () => {
    settingsPopupState.setShowPopup(true);
    settingsPopupState.setDefaultPopupvalue({
      cbk: () => settingsPopupState.setShowPopup(false),
      source,
    });
  };

  return (
    <Button
      id="changeSubscription"
      name="changeSubscription"
      type="button"
      className="primaryButton changeSubscriptionButton"
      btnText="Change Subscription"
      icon={false}
      loader={false}
      click={handleChangeSubscription}
    />
  );
};

export { ChangeSubscriptionPlan, ChangeSubscriptionPopupContent };
export default ChangeSubscriptionPlan;
